import http from '../utils/http';

/**
 * 请求地址
 * http://10.200.140.52:6066/ckips
 *
 * @param {obj} params
 * @returns Promise
 */

//请求列表(分页）
export function getList(params) {
    return http.post('/department/list', params, {

    })
}
//请求列表（树状图）
export function getTree(params) {
    return http.post('/department/listDepartmentTree', params, {

    })
}
//新增
export function save(params) {
    return http.post('/department/save', params, {

    })
}

//编辑
export function update(params) {
    return http.post('/department/update', params, {

    })
}
//启用，禁用
export function changeStatus(params) {
    return http.post('/department/enableDisableDepartment', params, {

    })
}

//删除
export function remove(params) {
    return http.post('/department/delete', params, {

    })
}
